export default "__VITE_ASSET__647a197f__"